// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Screen {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 26;
  background: #FFF;
}
.Screen h2, .Screen h3, .Screen h5, .Screen p {
  text-align: center;
  margin: 0;
}
.Screen h3 {
  padding-top: 21px;
  padding-bottom: 16px;
  background: #002E33;
  font-size: 16px;
  font-weight: normal;
  color: #FFF;
}
.Screen div.Button {
  font-size: 14px;
  padding: 12px 22px;
}
.Screen div.Content h2 {
  color: #002E33;
  font-size: 24px;
  font-weight: normal;
  padding-top: 48px;
  padding-bottom: 16px;
}
.Screen div.Content h5 {
  color: #697588;
  font-size: 16px;
  font-weight: normal;
}
.Screen div.Content p {
  color: #697588;
  font-size: 14px;
}
.Screen .Buttons {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 107px;
  border-top: 1px solid #E8E9F0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-line-pack: center;
      align-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: #FFF;
}
.Screen .Buttons div.Button {
  height: 16px;
  margin: 0 6px;
}
.Screen div.Close {
  cursor: pointer;
  text-transform: uppercase;
  z-index: 27;
  position: absolute;
  top: 22px;
  padding-left: 24px;
  left: 65px;
  color: #FFF;
  font-size: 12px;
}
.Screen div.Close:before {
  position: relative;
  top: 1px;
  content: "×";
  font-size: 20px;
  padding-right: 10px;
  line-height: 14px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/Screen/Screen.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBCDM;ADCR;AAEE;EACE,kBAAA;EACA,SAAA;AAAJ;AAGE;EACE,iBAAA;EACA,oBAAA;EACA,mBCjBW;EDkBX,eAAA;EACA,mBAAA;EACA,WCdI;ADaR;AAIE;EACE,eAAA;EACA,kBAAA;AAFJ;AAMI;EACE,cC9BS;ED+BT,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAJN;AAOI;EACE,cCaG;EDZH,eAAA;EACA,mBAAA;AALN;AAQI;EACE,cCOG;EDNH,eAAA;AANN;AAUE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,6BAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,0BAAA;MAAA,qBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,gBCtDI;AD8CR;AAUI;EACE,YAAA;EACA,aAAA;AARN;AAYE;EACE,eAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,WCtEI;EDuEJ,eAAA;AAVJ;AAYI;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAVN","sourcesContent":["@import \"src/client/Global/Colors\";\n\n.Screen {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 26;\n  background: $White;\n\n  h2, h3, h5, p {\n    text-align: center;\n    margin: 0;\n  }\n\n  h3 {\n    padding-top: 21px;\n    padding-bottom: 16px;\n    background: $DeepSeaGreen;\n    font-size: 16px;\n    font-weight: normal;\n    color: $White;\n  }\n\n  div.Button {\n    font-size: 14px;\n    padding: 12px 22px;\n  }\n\n  div.Content {\n    h2 {\n      color: $DeepSeaGreen;\n      font-size: 24px;\n      font-weight: normal;\n      padding-top: 48px;\n      padding-bottom: 16px;\n    }\n\n    h5 {\n      color: $Gray90;\n      font-size: 16px;\n      font-weight: normal;\n    }\n\n    p {\n      color: $Gray90;\n      font-size: 14px;\n    }\n  }\n\n  .Buttons {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 107px;\n    border-top: 1px solid $Gray30;\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    background: $White;\n\n    div.Button {\n      height: 16px;\n      margin: 0 6px;\n    }\n  }\n\n  div.Close {\n    cursor: pointer;\n    text-transform: uppercase;\n    z-index: 27;\n    position: absolute;\n    top: 22px;\n    padding-left: 24px;\n    left: 65px;\n    color: $White;\n    font-size: 12px;\n\n    &:before {\n      position: relative;\n      top: 1px;\n      content: \"×\";\n      font-size: 20px;\n      padding-right: 10px;\n      line-height: 14px;\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
